import { Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { AlertModalComponent, AlertType } from '../../shared/components/alert-modal/alert-modal.component';

export interface AlertOptions {
  type: AlertType;
  title: string;
  message: string;
  showCancel?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private popoverController: PopoverController) {}

  async showAlert(options: AlertOptions): Promise<void> {
    const popover = await this.popoverController.create({
      component: AlertModalComponent,
      cssClass: 'alert-modal',
      backdropDismiss: false,
      componentProps: {
        type: options.type,
        title: options.title,
        message: options.message,
        showCancel: options.showCancel ?? false
      }
    });
    await popover.present();
  }

  async showConfirm(options: Omit<AlertOptions, 'showCancel'>): Promise<boolean> {
    const popover = await this.popoverController.create({
      component: AlertModalComponent,
      cssClass: 'alert-modal',
      backdropDismiss: false,
      componentProps: {
        type: options.type,
        title: options.title,
        message: options.message,
        showCancel: true
      }
    });

    await popover.present();
    const { data } = await popover.onDidDismiss();
    return data?.result === true;
  }
}
